import { apiFetch } from "./client";

export interface AgentPrefs {
  lastUsedAgentId: string | null;
  pinnedAgentIds: string[];
}

export const userAgentPrefsApi = {
  get: () => apiFetch<AgentPrefs>("/me/agent-prefs"),

  touch: (agentId: string) =>
    apiFetch<{ ok: boolean }>("/me/agent-prefs/touch", {
      method: "PUT",
      body: JSON.stringify({ agentId }),
    }),

  setPinned: (agentId: string, pinned: boolean) =>
    apiFetch<{ ok: boolean; pinned: boolean }>("/me/agent-prefs/pin", {
      method: "PUT",
      body: JSON.stringify({ agentId, pinned }),
    }),
};
